package com.essntl.features.tag.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.unit.dp
import com.essntl.features.tag.domain.model.TagModel
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.icons.EsLargeIcon
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun TagDropDownItem(
    tag: TagModel,
    onClick: () -> Unit,
    selected: Boolean = false,
    modifier: Modifier = Modifier,
) {
    Row(
        horizontalArrangement = Arrangement.SpaceBetween,
        modifier = modifier
            .fillMaxWidth()
    ) {
        Box(
            modifier = Modifier
                .clip(CircleShape)
                .pointerHoverIcon(PointerIcon.Hand)
                .clickable(onClick = onClick)
                .background(with(MaterialTheme.esColorScheme) {
                    if (selected) tinted else bgSecondary
                })
                .border(
                    width = 1.dp,
                    color = with(MaterialTheme.esColorScheme) {
                        if (selected) tinted else borderPrimary
                    },
                    shape = CircleShape,
                )
                .padding(
                    horizontal = 1.5f.spacing,
                    vertical = 1.spacing,
                )
        ) {
            Text(
                text = tag.name,
                color = MaterialTheme.esColorScheme.textPrimary,
                style = MaterialTheme.esTypography.p2Regular14,
            )
        }

        if (selected) {
            EsLargeIcon(
                res = EsIcons.Tick,
                tint = MaterialTheme.esColorScheme.iconAccent,
            )
        }
    }
}